import { FieldError } from 'react-hook-form';

import { Language } from '@lessonPlanner/enums';

import { SelectField } from '../form-fields';

interface TranslationDropdownProps {
  errors: {
    language?: FieldError;
  };
  language: string;
  handleUpdateFieldValue: (fieldName: string, value: string) => void;
  handleTriggerValidation: (fieldName: string) => void;
}

export default function TranslationDropdown(props: TranslationDropdownProps) {
  const { errors, language, handleUpdateFieldValue, handleTriggerValidation } =
    props;

  return (
    <>
      <SelectField
        className="col-span-full"
        error={!!errors.language}
        errorMessage={errors.language?.message}
        id="language"
        label="Translation"
        name="language"
        value={language}
        onChange={(value) => handleUpdateFieldValue('language', value)}
        onBlur={() => {
          handleTriggerValidation('language');
        }}
      >
        {Object.values(Language).map((lang) => (
          <option key={lang} value={lang}>
            {' '}
            {lang}{' '}
          </option>
        ))}
      </SelectField>
    </>
  );
}
